var ca;

var AjaxForms = {

    options: {
        target: null,
        successFn: null,
        errorFn: null,
        method: 'POST',
        recaptcha: false

    },
    init: function( t ) {

        var $this = this;
        var $form = $( t );
       

        $this.options.target = t;
        $( $this.options.target ).parsley( {
            excluded: "input:hidden,select:hidden"
        } );


         if ($this.options.recaptcha === true) {
            $($this.options.target).on('submit', function ($e) {
                $e.preventDefault();

                if (typeof (grecaptcha) !== 'undefined') {
                    grecaptcha.ready(function () {

                        grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(function (token) {
                            $($this.options.target).append('<input class="gr-recaptcha" name="g-recaptcha-response" type="hidden" value="'+token+'"/>');
                            
                            $this.submit_form();
                        });
                    });
                }
            }).addClass('ready');

        } else {
            $($this.options.target).on('submit', function ($e) {
                $this.submit_form();
                $e.preventDefault();
            }).addClass('ready');
        }

        /* 
        $( $this.options.target ).on( 'submit', function( $e ) {

       if ( $form.find( 'input[name=payment_method]' ).length > 0 && $form.find( 'input[name=payment_method]:checked' ).val( ) == 'credit_card' ) {
                $valid_card = true;
                if ( $form.find( 'input[name=card_number]' ).length > 0 ) {
                    $form.find( 'input[name=card_number]' ).validateCreditCard( function( result ) {
                        if ( !result.valid ) {
                            post_id = false;
                            actionResponseModal( 'Invalid Card Number', 'error', '.actions-block .save' );
                            $valid_card = false;
                        }
                        $e.preventDefault( );
                    } );


                    $form.find( 'input[name=card_number]' ).off( 'input.jccv keyup.jccv' );
                    var $exp_date_year = Number( "20" + $form.find( 'select[name=exp_date_year]' ).val( ) );
                    var $exp_date_month = Number( $form.find( 'select[name=exp_date_month]' ).val( ) );
                    var $date = new Date( );


                    if ( $exp_date_year < $date.getFullYear( ) ) {
                        $valid_card = false;
                        actionResponseModal( 'Card Expired', 'error', '.actions-block .save' );
                    } else if ( $exp_date_year == $date.getFullYear( ) ) {
                        if ( $exp_date_month < $date.getMonth( ) + 1 ) {
                            $valid_card = false;
                            actionResponseModal( 'Card Expired', 'error', '.actions-block .save' );
                        }
                    }
                } else {
                    $valid_card = true;
                }
                if ( $valid_card ) {
                    $this.submit_form( $e );
                }

            } else {
                $this.submit_form( $e );
            }
            $this.submit_form( $e );
            $e.preventDefault( );
        } ).addClass( 'ready' );
        */
    },
    form_submit_response: function( msg, type ) {
        actionResponseModal( msg, type );
    },

    submit_form: function( $e ) {
        var $this = this,
            $form = $( $this.options.target ),
            successFn = $this.options.successFn,
            errorFn = $this.options.errorFn,
            url = $form.attr( 'action' ),
            postData = $form.serialize( ),
            method = $this.options.method || 'POST',
            $submitBTN = $form.find( 'button[type="submit"]' );
            if($form.attr('id') ==='checkout_step_3_form'){
              $('body').addClass('partial-loading');
              $('body').append('<div class="parial-loader"></div>');
            }

        $submitBTN.prop( 'disabled', true );
        $submitBTN.data( 'initialText', $submitBTN.text( ) );
        $.ajax( {
            url: url,
            data: postData,
            method: method,
            success: function( data ) {

                 if($form.attr('id') ==='checkout_step_3_form'){
                     $('body').removeClass('partial-loading');
                     $('body').find('.parial-loader').remove();
                }

                $submitBTN.prop( 'disabled', false );
                
                if($this.options.recaptcha ===  true){
                    if($form.find('.gr-recaptcha').length>0 ){
                                $($this.options.target).find('.gr-recaptcha').remove();
                            }
                }

                if ( data.status && data.status == 'error' ) {
                    $this.form_submit_response( data.message, 'error' );

                } else {
                    $form.find( 'input,textarea,select' ).not( ':hidden' ).each( function( ) {
                        $( this ).removeClass( 'parsley-success' );
                        $(this).val('');
                    } );

                    if ( typeof( successFn ) !== 'undefined' && typeof( successFn ) !== null && successFn!==null && successFn!== '' ) {
                        successFn( data );
                    } else {
                        $this.form_submit_response( data.message, 'success' );
                    }
                 
                }

                 if ( data.redirect ) {
                    window.location = data.redirect;
                    return false;
                }


            },
            error: function( response ) {

                 if($form.attr('id') ==='checkout_step_3_form'){
                     $('body').removeClass('partial-loading');
                     $('body').find('.parial-loader').remove();
                }
                
                if($this.options.recaptcha ===  true){
                    if($form.find('.gr-recaptcha').length>0 ){
                        $($this.options.target).find('.gr-recaptcha').remove();
                    }
                }

                $submitBTN.text( $submitBTN.data( 'initialText' ) );
                $submitBTN.prop( 'disabled', false );

                //errors
                var responseJSON = jQuery.parseJSON( response.responseText );
                if ( typeof responseJSON.errors !== "undefined" ) {
                    responseJSON = responseJSON.errors;
                }

                if ( errorFn !== null && typeof( errorFn ) == 'function' ) {
                    errorFn(responseJSON);
                } else {
                    
                    for ( var i in responseJSON ) {
                    
                        if(i=='g-recaptcha-response'){
                             $this.form_submit_response( responseJSON[ i ], 'error' );
                        }else{

                             i= i.replace('.', '[');
                             if (i.includes('[') ){
                                 i= i+']';
                             }
                            

                            var t = $form.find( '[name="' + i + '"]' ).closest( '.form-group' );
                            t.find( '[name="' + i + '"]' ).addClass( 'parsley-error' );

                            if ( t.find( '.parsley-errors-list' ).length > 0 ) {

                                if ( typeof responseJSON[ i ] === 'string' ) {
                                    t.find( '.parsley-errors-list' ).html( '<li class="parsley-type">' + responseJSON[ i ] + '</li>' );
                                } else {
                                    t.find( '.parsley-errors-list' ).html( '<li class="parsley-type">' + responseJSON[ i ].join( '' ) + '</li>' );
                                }
                            } else {
                                if ( typeof responseJSON[ i ] === 'string' ) {
                                    t.append( '<ul class="parsley-errors-list filled"><li class="parsley-type">' + responseJSON[ i ] + '</li></ul>' );
                                } else {

                                    t.append( '<ul class="parsley-errors-list filled"><li class="parsley-type">' + responseJSON[ i ].join( '' ) + '</li></ul>' );
                                }
                            }

                        }
                        
                    }
                }
            }

        } );
    }
}


var ContactForm = $.extend( {}, AjaxForms, {
    options: {
        api_route: 'contact',
        recaptcha: true
    }
} );

var Newsletter = $.extend( {}, AjaxForms, {
    options: {
        api_route: 'api/newsletter'
    }
} );

var AddReview = $.extend( {}, AjaxForms, {
    options: {
        api_route: 'api/add-review'
    }
} );
var AddUserVehicle = $.extend( {}, AjaxForms, {
    options: {
        api_route: 'api/add-user-vehicle',
        successFn: function( ) {
            window.location.reload( );
        }
    }
} );

var CloseAccountForm = $.extend( {}, AjaxForms, {
    options: {
        api_route: 'api/close-account'
    }
} );


var CancelSubscriptionForm = $.extend( {}, AjaxForms, {
    options: {
        api_route: 'api/cancel-subscription',
        successFn: function( ) {
            window.location.reload( );
        }
    }
} );

var RenewSubscriptionForm = $.extend( {}, AjaxForms, {
    options: {
        api_route: 'api/renew-subscription',
        successFn: function( ) {
            window.location.reload( );
        }
    }
} );



var productsForm = $.extend( {}, AjaxForms, {
    options: {
        api_route: 'products',
        recaptcha: false,
        successFn: function( ) {
           // window.location.reload( );
        }
        
    }
} );

var CheckoutStep0 = $.extend( {}, AjaxForms, {
    options: {
        api_route: '/sales/progress',
        successFn: function( data ) {
            CheckOutStep( data );
        },
        errorFn: function( data ) {
            
            actionResponseModal( data.message, 'error' );
        }
    }
} );

var CheckoutStep1 = $.extend( {}, AjaxForms, {
    options: {
        api_route: '/sales/progress',
        successFn: function( data ) {
            CheckOutStep( data );
        },
        errorFn: function( data ) {
            
            actionResponseModal( data.message, 'error' );
        }
    }
} );
var CheckoutStep2 = $.extend( {}, AjaxForms, {
    options: {
        api_route: '/sales/progress',
        successFn: function( data ) {
            CheckOutStep( data );
        }
    }
} );
var CheckoutStep3 = $.extend( {}, AjaxForms, {
    options: {
        api_route: '/sales/progress',
        successFn: function( data ) {
            CheckOutStep( data );
        }
    }
} );

var PlaceOrder = $.extend( {}, AjaxForms, {
    options: {
        api_route: '/sales/progress',
        successFn: function( data ) {
            CheckOutStep( data );
        }
    }
} );


var ChangePasswordForm = $.extend( {}, AjaxForms, {
    options: {
        recaptcha: false,
        api_route: 'api/update-password'
    }
} );
var ForgotPasswordForm = $.extend( {}, AjaxForms, {
    options: {
        recaptcha: false,
        api_route: 'api/forgot_password'
    }
} );


/*
$(function(){
    $('form#newsletter_form').submit(function(){
        $('.newsletter-form .email-prefs').addClass('show-prefs');    
        $('.newsletter-form .animate').addClass('shown');    
        fitmentSearch.init('footer');
        NewsletterEmailPrefs.init('#emailprefs_form');
    });
    $('.newsletter-form .email-prefs .close_prefs').click(function(){
        $('.newsletter-form .email-prefs').removeClass('show-prefs');        
        $('.newsletter-form .animate').removeClass('shown');    
        return false;
    });
});*/

function catchaLoadedCallback( ) {
    captcha_ready = true;
}

function sendFeedback( $this, $feed ) {
    var $form = $this.parent( );
    $form.find( 'input[name="feedback" ]' ).val( $feed );

    $.ajax( {
        url: $form.attr( 'action' ),
        data: $form.serialize( ),
        success: function( data ) {
            if ( data.status === "ok" ) {
                actionResponseModal( data.message, 'success' );
            } else if ( data.status === 'error' ) {
                actionResponseModal( data.message, 'error' );
            } else {
                actionResponseModal( LOCALE.general_error, 'error' );
            }
        }
    } );
}